import { makeAutoObservable, observable } from 'mobx';
import { RootStore } from './RootStore';

export class UTMStore {
  root: RootStore;
  initialized = false; // Initialization flag
  utmParams: Record<string, string> = {};

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this, {
      utmParams: observable,
      initialized: observable,
    });
  }

  initStoreOnClientSide = () => {
    const storedParams = localStorage.getItem('utm_params');
    if (storedParams) {
      this.utmParams = JSON.parse(storedParams);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const query = Object.fromEntries(urlParams.entries());

    const newUTMParams = this.utmParamsFromQuery(query);

    this.utmParams = { ...this.utmParams, ...newUTMParams };
    localStorage.setItem('utm_params', JSON.stringify(this.utmParams));
    this.initialized = true;
  };

  clearUTMParameters = () => {
    this.utmParams = {};
    localStorage.removeItem('utm_params');
  };

  private utmParamsFromQuery(query: { [key: string]: string }): {
    [key: string]: string;
  } {
    return Object.keys(query)
      .filter((key) => key.startsWith('utm'))
      .reduce((obj: any, key: string) => {
        obj[key] = query[key];
        return obj;
      }, {});
  }
}
